<template>
  <div class="userinfo ">
    <div class="mt-10" style="margin-right:60px;width:600px;margin-top:35px;padding-left:20px">
      <div class="inline-block text-xl title-line user_info_title">
        投诉与建议
      </div>
      <div class="flex" style="width:810px;">
        <n-form-item style="margin-top:56px;margin-left:40px;width:640px;" label="提交您的意见："
          :label-style="{ fontSize: '22px' }">
          <n-input v-model:value="content" placeholder="请输入您的意见" type="textarea" show-count :rows="10"
            maxlength="200" />
        </n-form-item>
        <div class="flex justify-center" style="width:120px;height:40px;align-self:flex-end;margin-left:30px;">
          <el-button class="px-10 allbtncolor" style="margin-top:0" :loading="loading" type="primary" @click="submit">提
            交</el-button>
        </div>
      </div>
      <!-- <div class="flex justify-center" style=" ">
        <el-button class="px-10 allbtncolor" :loading="loading" type="primary" @click="submit">提 交</el-button>
      </div> -->
      <div class="inline-block text-xl title-line user_info_title" style="margin-top:50px;">
        提交记录
      </div>
      <div style="height: 400px; overflow: auto;margin-left:40px;margin-top:46px;line-height: 35px;width: 620px;"
        v-if="yijianData.length != 0">
        <div v-for="(item, index) in yijianData" :key="index">
          <span class="hongdian"></span>
          {{ item.content }}
        </div>
      </div>
      <div style="height: 400px; overflow: auto;margin-left:40px;margin-top:46px;line-height: 35px;width: 620px;"
        v-else>
        <n-empty description="暂无记录"> </n-empty>
      </div>
    </div>

    <div class="remark mt-10" v-if="0" style="flex:1;">
      <p style="font-size: 22px; margin-bottom: 10px" class="user_info_title">提交记录 :</p>
      <div style="height: 400px;width:620px;overflow: auto" v-if="yijianData.length != 0">
        <div v-for="(item, index) in yijianData" :key="index">
          <span class="hongdian">{{ index + 1 }}. </span>
          {{ item.content }}
        </div>
      </div>
      <div v-else>
        <n-empty description="暂无记录"> </n-empty>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, shallowRef } from 'vue';
import { saveFeedbackApi, listFeedback } from '@/api';

const content = ref('');
const loading = ref(false);

async function submit () {
  if (content.value.trim() === '') {
    return window.message.warning('请输入您要提交的意见');
  }
  loading.value = true;
  try {
    const res = await saveFeedbackApi(content.value);
    if (res.success) {
      window.message.success('提交成功');
      initial();
    } else {
      throw new Error(res.msg);
    }
  } catch (err) {
    window.message.error(err.message || '提交失败');
  }
  loading.value = false;
}

function initial () {
  listFeedback().then(res => {
    console.log(res);
    yijianData.value = res.data;
    console.log(yijianData);
  });
}

// 查询意见返回列表信息
const yijianData = shallowRef([]);
onMounted(() => {
  console.log('我是意见反馈');
  initial();
});
</script>

<style lang="scss" scoped>
.border-bottoms {
  border-bottom: 1px solid rgba(209, 213, 219);
}
.title-line {
  position: relative;
  text-align: left;
  padding-bottom: 10px;
  &:after {
    position: absolute;
    content: '';
    height: 6px;
    width: 44px;
    background-color: #2d60f6;
    left: 0;
    bottom: -5px;
    transform: translateX(0);
  }
}
</style>
<style scoped>
:deep(.n-input-wrapper) {
  resize: none !important;
}
.hongdian {
  font-size: 1px;
  height: 7px;
  width: 7px;
  border: 1px solid #fe0000;
  background-color: #fe0000;
  border-radius: 50%;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  -webkit-text-stroke: 1px #fe0000;
  display: inline-block;
  margin-bottom: 3px;
  margin-right: 10px;
}
.remark {
  /* border: 1px solid #e0e0e6; */
  height: 438px;
}
.user_info_title {
  font-size: 22px;
  font-weight: normal;
  color: #111;
}
.userinfo {
  padding-right: 50px;
}
</style>
<style >
.userinfo .n-form-item-label {
  font-size: 22px;
  font-weight: normal;
  color: #111;
  margin-bottom: 30px;
}
.userinfo .n-input--textarea {
  margin-top: 10px;
}
.userinfo .n-form-item-feedback-wrapper {
  display: none;
}
</style>
